import { Injectable, Injector } from '@angular/core';
import { HelpConfig } from '@config/help-config';
import { GrupoLancamentoModel } from '@models/financeiro/grupo-lancamento.model';
import { BaseResourceService } from '@core/services/outros/base-resource.service';

@Injectable({
  providedIn: 'root'
})
export class GrupoLancamentoService extends BaseResourceService<GrupoLancamentoModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.FINANCIAL_API}grupolancamento`, injector);
  }
}
